import { Col, Divider, Form, FormInstance, Row, Typography } from 'antd';
import { isInputRequired } from '../../../constants/subjects';
import { supComplexDisorders } from '../../../constants/sup';

type DocumentPreviewRegistrationProps = {
  form: FormInstance;
  registrationData?: Record<string, string | boolean>;
};

export const DocumentPreviewRegistration = ({
  form,
  registrationData,
}: DocumentPreviewRegistrationProps) => {
  if (!registrationData) {
    return <></>;
  }

  const selectedSubject = Form.useWatch(
    ['registration', 'selectedSubject'],
    form,
  );

  const objectives = registrationData.objectives;
  const tasks = registrationData.tasks;

  const supLevel = registrationData?.supLevel;
  const supGroup = registrationData?.supGroup;
  const supSubGroup = registrationData?.supSubGroup;
  const isSupSubGroupComplex = supSubGroup === supComplexDisorders;
  const supSpecific = registrationData?.supSpecific;
  const supSubSpecific = registrationData?.supSubSpecific;

  return (
    <>
      <Row
        style={{
          margin: '0 auto',
          maxWidth: 420,
        }}
      >
        <Col style={{ textAlign: 'center' }} span={24}>
          <Typography.Title level={4}>
            {registrationData?.schoolName}
          </Typography.Title>
          <Divider style={{ margin: '0 auto', maxWidth: '49px' }} />
          <Typography.Text type="secondary" style={{ fontSize: 'smaller' }}>
            Mokyklos pavadinimas
          </Typography.Text>
        </Col>
      </Row>

      <Row>
        <Col span={10}>
          <Typography.Title level={5} style={{ marginBottom: 0 }}>
            Mokinio (-ės) vardas, pavardė
          </Typography.Title>
          <Typography.Text>{registrationData?.student}</Typography.Text>

          <Typography.Title level={5} style={{ marginBottom: 0 }}>
            Mokslo metai
          </Typography.Title>
          <Typography.Text>
            {`${registrationData?.schoolYear} ${registrationData?.adaptationPeriod}`}
          </Typography.Text>

          <Typography.Title level={5} style={{ marginBottom: 0 }}>
            Gimimo metai
          </Typography.Title>
          <Typography.Text>{registrationData?.birthYear}</Typography.Text>
        </Col>
        <Col span={14} style={{ textAlign: 'end' }}>
          <Typography.Title level={5} style={{ marginBottom: 0 }}>
            Dalykas, kuriam rengiama pritaikyta programa
          </Typography.Title>
          <Typography.Text>
            {isInputRequired(selectedSubject)
              ? `${registrationData?.selectedSubject}: ${registrationData?.selectedSubjectInput || ''}`
              : registrationData?.selectedSubject}
          </Typography.Text>

          <Typography.Title level={5} style={{ marginBottom: 0 }}>
            Programą parengė
          </Typography.Title>
          <Typography.Text>{registrationData?.eduSpecialist}</Typography.Text>

          <Typography.Title level={5} style={{ marginBottom: 0 }}>
            Klasė
          </Typography.Title>
          <Typography.Text>{registrationData?.grade}</Typography.Text>
        </Col>
      </Row>
      <Row gutter={12}>
        {objectives && (
          <Col span={12}>
            <Typography.Title level={5} style={{ marginBottom: 0 }}>
              Tikslai
            </Typography.Title>
            <Typography.Text>{objectives}</Typography.Text>
          </Col>
        )}
        {tasks && (
          <Col span={12}>
            <Typography.Title level={5} style={{ marginBottom: 0 }}>
              Uždaviniai
            </Typography.Title>
            <Typography.Text>{tasks}</Typography.Text>
          </Col>
        )}
      </Row>
      <Row gutter={12}>
        {supLevel && (
          <Col span={12}>
            <Typography.Title level={5} style={{ marginBottom: 0 }}>
              SUP lygis
            </Typography.Title>
            <Typography.Text>{supLevel}</Typography.Text>
          </Col>
        )}
        {supGroup && (
          <Col span={12}>
            <Typography.Title level={5} style={{ marginBottom: 0 }}>
              SUP grupė
            </Typography.Title>
            <Typography.Text>{supGroup}</Typography.Text>
          </Col>
        )}
      </Row>
      <Row gutter={12}>
        {supSubGroup && (
          <Col span={12}>
            <Typography.Title level={5} style={{ marginBottom: 0 }}>
              SUP grupės tipas
            </Typography.Title>
            <Typography.Text>
              {isSupSubGroupComplex
                ? `${supSubGroup}: ${registrationData?.supSubGroupInput}`
                : supSubGroup}
            </Typography.Text>
          </Col>
        )}
        {supSpecific && (
          <Col span={12}>
            <Typography.Title level={5} style={{ marginBottom: 0 }}>
              Sutrikimas
            </Typography.Title>
            <Typography.Text>{supSpecific}</Typography.Text>
          </Col>
        )}
        {supSubSpecific && (
          <Col span={12} offset={12}>
            <ul
              style={{
                marginBlockStart: '0.5em',
                marginBlockEnd: '0.5em',
                paddingInlineStart: '20px',
              }}
            >
              {Object.entries(supSubSpecific).map(
                ([subSpecName, subSpecValue]: [any, string]) => {
                  return <li key={subSpecValue}>{subSpecValue}</li>;
                },
              )}
            </ul>
          </Col>
        )}
      </Row>
    </>
  );
};
